<script>
    import { onMount } from "svelte";

    import { fly } from "svelte/transition";

    import { isMobile } from "../../stores";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        SearchInput,
        PageLoading,
        SvelteTable,
        ResetFilterLink,
        DefaultDoctorFilter,
        DoctorMultiSearchSelect,
    } from "../../Components/Common/index.svelte";

    import {
        getFormatDateAndTime,
        getText,
        replaceURL,
        getDisplayUserName,
        decodeSearchParams,
        encodeSearchParams,
        syncDefaultDoctorFilter,
        getDaysDifferFrom,
        viewLog,
        getActivityLogsActionType,
        getTodayWithTime,
        getFormatDateAndTimeWithSeconds,
    } from "../../Utils/utilFunctions.svelte";

    import { user } from "../../stores";

    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";

    import { DefaultLogsTraceBackDays } from "../../Utils/utilConstants.svelte";

    import { LogTypes } from "../../Utils/utilEnums.svelte";
    import SearchDateRangeInput from "../../Components/Common/SearchDateRangeInput.svelte";

    export let params = {};

    let isLoadingUnauthorisedLogs = false,
        returnedUnauthorisedLogsArr = [],
        filters = {};

    let page = 0,
        pageSize = 25,
        count;

    let selectedDoctors = [];

    let showFilters = false;

    $: isUserEnableSeeAllFilters = $user.role >= 20;

    const LIMIT_TEXT_LENGTH = 50;

    const columns = [
        {
            key: "date",
            title: "Date",
            headerClass: "text-left pl-3 cursor-default rounded-tl-xl w-[15%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getFormatDateAndTimeWithSeconds(v.createdDate),
        },
        {
            key: "user",
            title: "User",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getDisplayUserName(v),
        },
        {
            key: "actionType",
            title: "Action Type",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getActivityLogsActionType(v.actionType),
        },
        {
            key: "controller",
            title: "Controller",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.controller),
        },
        {
            key: "actionId",
            title: "ID",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.id),
        },
        {
            key: "source",
            title: "Source",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default",
            value: (v) => getText(v.source),
        },
        {
            key: "reason",
            title: "Reason",
            headerClass: "text-left pl-3 cursor-default w-[30%] rounded-tr-xl",
            class: "text-left px-3 cursor-default",
            renderValue: (v) => _getTextWithTrim(v.reason),
            csvContent: (v) => _getTextWithTrim(v.reason, true),
        },
    ];

    onMount(async () => {
        if (params.query) await updateSearchParamsByQuery(params.query);

        filters = await syncDefaultDoctorFilter(filters, "doctorId");

        // if (!filters.dateFrom) {
        //     filters.dateFrom = getDaysDifferFrom(
        //         -1 * DefaultLogsTraceBackDays,
        //         new Date(),
        //     );
        //     updateURL();
        // }

        loadUnauthorisedLogs(page * pageSize, pageSize, _getSearchParams());
    });

    const updateSearchParamsByQuery = async (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("search="))
                    filters.search = arr[i].split("=")[1];

                if (arr[i].includes("fromDate="))
                    filters.dateFrom = arr[i].split("=")[1];

                if (arr[i].includes("toDate="))
                    filters.dateTo = arr[i].split("=")[1];

                if (isUserEnableSeeAllFilters) {
                    if (arr[i].includes("doctorId=")) {
                        if (isNaN(arr[i].split("=")[1])) {
                            filters.doctorId = arr[i].split("=")[1];
                            selectedDoctors = filters.doctorId
                                .split(",")
                                .map((id) => Number(id));
                        } else {
                            filters.doctorId = Number(arr[i].split("=")[1]);
                            selectedDoctors = [Number(filters.doctorId)];
                        }
                    }
                }
            }

            updateURL();
        }
    };

    const loadUnauthorisedLogs = async (start, limit, params) => {
        isLoadingUnauthorisedLogs = true;

        await apiMethods.getMethod
            .getUnauthorisedLogs(start, limit, params)
            .then((res) => _handleUnauthorisedLogs(res));

        isLoadingUnauthorisedLogs = false;
    };

    const handleFilterSelect = () => {
        page = 0;

        updateURL();

        loadUnauthorisedLogs(0, pageSize, _getSearchParams());
    };

    const updateURL = () => {
        replaceURL(
            `/UnauthorisedLogs/page=${page}&size=${pageSize}${_getParamsString()}`,
        );
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadUnauthorisedLogs(
            Number(e.detail.firstDataIndex),
            pageSize,
            _getSearchParams(),
        );
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadUnauthorisedLogs(0, newPageSize, _getSearchParams());
    };

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {
        viewLog(LogTypes.Unauthorised, rowData.id);
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    const filterTransition = (node, args) => ($isMobile ? fly(node, args) : "");

    const toggleFilters = () => (showFilters = !showFilters);

    const handleSelectDoctor = () => {
        filters.doctorId = selectedDoctors.join(",");

        handleFilterSelect();
    };

    const clearFilterDoctor = () => {
        selectedDoctors = [];

        delete filters.doctorId;

        handleFilterSelect();
    };

    // HELPER FUNCTIONS
    const _handleUnauthorisedLogs = async (res) => {
        if (res.error) showError(res.error);
        else {
            returnedUnauthorisedLogsArr = [...res.results];

            count = res.total;
        }
    };

    const _getSearchParams = () => {
        let params = {};

        if (filters.search) params.search = filters.search;

        if (filters.dateFrom) params["filter[dateFrom]"] = filters.dateFrom;

        if (filters.dateTo) params["filter[dateTo]"] = filters.dateTo;

        if (filters.doctorId) params["filter[doctorId]"] = filters.doctorId;

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.search) str += `&search=${params.search}`;

            if (params["filter[dateFrom]"])
                str += `&fromDate=${params["filter[dateFrom]"]}`;

            if (params["filter[dateTo]"])
                str += `&toDate=${params["filter[dateTo]"]}`;

            if (isUserEnableSeeAllFilters) {
                if (params["filter[doctorId]"])
                    str += `&doctorId=${params["filter[doctorId]"]}`;
            }
        }

        return encodeSearchParams(str);
    };

    const _getTextWithTrim = (text, isCsvContent = false) => {
        if (isCsvContent) return text;

        const displayText =
            text.length <= LIMIT_TEXT_LENGTH
                ? text
                : text.slice(0, LIMIT_TEXT_LENGTH) + "...";

        return `
                <div class="w-full break-all">
                    ${displayText}
                </div>
                `;
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if $isMobile}
        <button
            class="btn btn-accent btn-sm w-28 flex flex-row gap-x-3"
            on:click={toggleFilters}
        >
            Filters
            <i
                style="font-size:20px"
                class={showFilters ? "fa arrow-up" : "fa arrow-down"}
                >&#xf104;
            </i>
        </button>
    {/if}

    {#if showFilters || !$isMobile}
        <div
            class="flex flex-wrap flex-row gap-4 items-end"
            in:filterTransition={{ duration: 200, y: -100 }}
        >
            <SearchInput
                bind:value={filters.search}
                title="Search"
                inputFunc={handleFilterSelect}
            />

            <!-- {#if isUserEnableSeeAllFilters}
                <DefaultDoctorFilter
                    bind:filter={filters}
                    filterPropertyName={"doctorId"}
                    onChangeFunc={handleFilterSelect}
                />

                <DoctorMultiSearchSelect
                    bind:searchResult={selectedDoctors}
                    onChangeFunc={handleSelectDoctor}
                    inputClass="w-32"
                    zIndex="3"
                />
            {/if} -->

            {#if !$user.settings?.disableDateRangeInput}
                <SearchDateRangeInput
                    bind:startDate={filters.dateFrom}
                    bind:endDate={filters.dateTo}
                    title="Date Range"
                    inputClass="borderB w-[272px]"
                    on:change={handleFilterSelect}
                    showClearButton
                    disable={isLoadingUnauthorisedLogs}
                    showScrollYearOptions
                    maxYear={new Date(`${getTodayWithTime()}:00`)}
                />
            {:else}
                <SearchInput
                    bind:value={filters.dateFrom}
                    title="Date from"
                    type="date"
                    inputClass="borderB"
                    inputFunc={handleFilterSelect}
                    isDisable={isLoadingUnauthorisedLogs}
                    maxDate={filters.dateTo ?? undefined}
                    showScrollYearOptions
                    maxYear={new Date(`${getTodayWithTime()}:00`)}
                />

                <SearchInput
                    bind:value={filters.dateTo}
                    title="Date to"
                    type="date"
                    inputClass="borderB"
                    inputFunc={handleFilterSelect}
                    isDisable={isLoadingUnauthorisedLogs}
                    maxDate={filters.dateFrom ?? undefined}
                    showScrollYearOptions
                    maxYear={new Date(`${getTodayWithTime()}:00`)}
                />
            {/if}

            <ResetFilterLink
                bind:filter={filters}
                onResetFilter={clearFilterDoctor}
            />
        </div>
    {/if}

    <div class="relative flex-1">
        {#if isLoadingUnauthorisedLogs}
            <PageLoading />
        {:else}
            <div class="overflow-y-auto absolute inset-0">
                <SvelteTable
                    {columns}
                    rows={returnedUnauthorisedLogsArr}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />
            </div>
        {/if}
    </div>

    <TableFooter
        {page}
        {pageSize}
        {count}
        tableData={returnedUnauthorisedLogsArr}
        {onPageChange}
        {onPageSizeChange}
        csvConfig={{
            columns,
            data: returnedUnauthorisedLogsArr,
            fileName: "Unathorised Logs",
            allDataApi: async () =>
                await apiMethods.getMethod.getUnauthorisedLogs(
                    0,
                    999999,
                    _getSearchParams(),
                ),
        }}
    />
</div>
